import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import window, {IAmazonError} from "../../../lib/WindowExtended";
import {useEffect} from "react";
import {amazonPayWalletReadableContainerId, widgetOptions} from "../../../lib/payments/AmazonPayLibrary";
import styles from "./Summary.module.scss";
import {INTERNAL_ERROR_TYPE} from "../../../lib/payments/PaymentController";

interface ISummaryPaymentOptionProps {
  goToPaymentView: () => void;
  onError: (error: Error, occurence: string) => void;
}

const SummaryPaymentOption: React.FC<ISummaryPaymentOptionProps> = (props) => {
  const {checkout} = useCheckoutContext();
  const {t} = useTranslation("checkout");
  const {goToPaymentView} = props;

  useEffect(() => {
    if (!window.isBillingAgreementPaymentSet || !window.amazon) {
      return;
    }

    const errorHandling = (err: IAmazonError) => {
      const tempError = new Error(`[AmazonPayReadableWalletWidget] ${err.getErrorCode()}: ${err.getErrorMessage()}`);
      tempError.name = INTERNAL_ERROR_TYPE.AMAZON.readableWalletWidget + "Error";
      props.onError(tempError, "Amazon Readable Wallet Widget");
    };

    new window.OffAmazonPayments.Widgets.Wallet({
      ...widgetOptions,
      amazonOrderReferenceId: window.orderReferenceId,
      onError: errorHandling,
      displayMode: "Read",
    })
      .setPresentmentCurrency(window.c_ActiveCurrency)
      .bind(amazonPayWalletReadableContainerId);
  }, []);

  let name = t("Keine gültige Zahlungsart");
  let description = t("Bitte gehen Sie in den Kassenschritt 'Bezahlung'");

  const {paymentInformation} = checkout.cartData;
  if (paymentInformation) {
    name = paymentInformation.paymentName || checkout.paymentId?.toString() || "";
    description = paymentInformation.paymentDescription;
  }

  const isAmazon = window.isBillingAgreementPaymentSet;

  return (
    <React.Fragment>
      <h2>{t("Zahlungsoptionen")}</h2>

      {!isAmazon && (
        <span className={styles.pen} onClick={goToPaymentView}>
          <span className="Svg Svg-Icon-Pen">&#160;</span>
        </span>
      )}

      {isAmazon ? (
        <div className="SimpleRadioList">
          <div id={amazonPayWalletReadableContainerId} style={{height: "150px", marginBottom: "2rem"}}>
            {/* Filled by Amazon Pay */}
          </div>
        </div>
      ) : (
        <div className="SimpleRadioList ArrowBorder">
          <div className="SimpleRadioList__SingleLine">
            <p dangerouslySetInnerHTML={{__html: name}} />
            <p dangerouslySetInnerHTML={{__html: description}} />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default SummaryPaymentOption;
